export const MAINTENANCE_BYPASS_STORAGE_KEY = 'maintenance-bypass';
export const MAINTENANCE_BYPASS_HEADER = 'X-Maintenance-Bypass';
export const MAINTENANCE_STATE_EVENT = 'maintenance-state-changed';

let maintenanceModeActive = false;
const maintenanceStateListeners = new Set();

export function getMaintenanceBypassToken() {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const token = window.localStorage.getItem(MAINTENANCE_BYPASS_STORAGE_KEY);
    return token?.trim() || null;
  } catch {
    return null;
  }
}

export function getMaintenanceModeSnapshot() {
  return maintenanceModeActive;
}

export function subscribeToMaintenanceMode(listener) {
  maintenanceStateListeners.add(listener);
  return () => maintenanceStateListeners.delete(listener);
}

export function setMaintenanceMode(active) {
  const nextState = Boolean(active);
  const changed = maintenanceModeActive !== nextState;
  maintenanceModeActive = nextState;

  if (changed) {
    maintenanceStateListeners.forEach((listener) => listener());
  }

  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent(MAINTENANCE_STATE_EVENT, {
        detail: { maintenance: nextState },
      })
    );
  }
}

async function updateMaintenanceStateFromResponse(response) {
  if (response?.status !== 503) {
    return;
  }

  try {
    const payload = await response.clone().json();
    if (payload?.maintenance === true) {
      setMaintenanceMode(true);
    }
  } catch {
    // A non-JSON 503 is not the maintenance response contract.
  }
}

/**
 * Fetch a Careit backend resource with maintenance bypass and response
 * handling applied. Do not use this wrapper for third-party requests.
 */
export async function maintenanceFetch(input, init = {}) {
  const requestHeaders =
    typeof Request !== 'undefined' && input instanceof Request
      ? input.headers
      : undefined;
  const headers = new Headers(init.headers ?? requestHeaders);
  const bypassToken = getMaintenanceBypassToken();

  if (bypassToken) {
    headers.set(MAINTENANCE_BYPASS_HEADER, bypassToken);
  }

  const response = await window.fetch(input, { ...init, headers });
  await updateMaintenanceStateFromResponse(response);
  return response;
}
